import React, { useEffect, useState } from 'react';
import { Menu_ventas } from '../menu_ventas';
import { Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow, Paper, Typography, Stack, TextField, Box } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faTrash } from '@fortawesome/free-solid-svg-icons';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

import '../../../css/empresa_uno/ventas.css';
import pdf from '../../../images/pdf.png';
import buscar_azul from '../../../images/search_azul.png';
import pdfIcon from "../../../images/pdf.png";

import { ApiService } from '../../ApiService';
import { useParams } from 'react-router-dom';
import { useCompanyAssigned } from "../../CompanyAssignedContext";
import LupaIcon from '../../../svg/lupaIcon';
import SearchCompany from '../../../pages/empresa_uno/SearchCompany';
import TablesMobile from '../../empresa/TablesMobile';

export const VnotaCaja = ({ selectedSucursal, convertPrice = (() => { }) }) => {
  const { nit, sub_direc } = useParams();

  const [sucursales, setSucursales] = useState([]);
  const [objNoteCash, setObjNoteCash] = useState([]);
  const [fechaIni, setFechaIni] = useState(null);
  const [fechaFin, setFechaFin] = useState(null);
  const [currentSize, setCurrentSize] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setCurrentSize(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    // Cleanup function para quitar el listener cuando el componente se desmonte
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const fech_noteCash = async (key_branch, fecha1, fecha2) => {
    const url = `api/company/cash/notes?start_date=${fecha1}&end_date=${fecha2}&key_branch=${key_branch}`;
    const options = { method: 'GET' };

    const request_totals = await ApiService.fetchData(url, options);

    if (!request_totals) {
      alert('Error al cargar los datos de ventas del día');
      return;
    }

    setObjNoteCash(request_totals);
  };

  useEffect(() => {
    const current_suc = selectedSucursal;
    const comp_date = new Date();
    const currentDate = `${comp_date.getFullYear()}-${String(comp_date.getMonth() + 1).padStart(2, '0')}-${String(comp_date.getDate()).padStart(2, '0')}`;

    if (fechaIni == null && fechaFin == null) {
      setFechaFin(currentDate);
      setFechaIni(currentDate);
    }

    setSucursales(current_suc);
    fech_noteCash(current_suc, fechaIni || currentDate, fechaFin || currentDate);
  }, [selectedSucursal]);

  const handleView = (row) => {
    console.log('Ver detalles de:', row);
  };

  function handleChange(e, comp) {
    comp == 1 ? setFechaIni(e) : setFechaFin(e);

    fech_noteCash(sucursales,
      (comp == 1 ? e : fechaIni),
      (comp == 2 ? e : fechaFin)
    );
  }

  const handleDelete = (row) => {
    console.log("Eliminar:", row);
  };
  // Datos estáticos de la tabla
  const totalGeneral = objNoteCash && objNoteCash.reduce((acc, note) => (parseFloat(acc) + parseFloat((note.type == 0 ? '-' : '') + note.total)).toFixed(2), 0);

  const returnTotal = () => {
    return totalGeneral;
  }

  return (
    <div>
      <div className="functionality-container">
        <div className="header-reports">
          <h2 style={{ color: 'var(--theme-company)' }}>Nota de Caja</h2>

          <div style={{ display: "flex", flexDirection: "row", gap: "20px" }}>
            <TextField
              label="Fecha Inicial"
              type="date"
              value={fechaIni}
              onChange={(e) => handleChange(e.target.value, 1)}
              size="small"
              sx={{ width: "150px" }}
              InputLabelProps={{
                shrink: true,
              }}
            />

            <TextField
              label="Fecha Fin"
              type="date"
              value={fechaFin}
              onChange={(e) => handleChange(e.target.value, 2)}
              size="small"
              sx={{ width: "150px" }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </div>

          <div>
            <SearchCompany theme={'var(--theme-company)'} placeholder="nota de caja" />

            <div style={{ display: 'none' }}>
              <button className="btn-add-var">
                <img className="icon-down pdf-icon" src={pdfIcon} alt="pdf" />
                <span className="txt-add">PDF</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      {
        currentSize > 480 ? (
          <div className="table-view-pc">
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow sx={{ backgroundColor: 'var(--theme-company)' }}>
                    {['Fecha', 'N.- Nota', 'Nombre', 'Cel. de Adm', 'Total']
                      .map((header, index) => (
                        <TableCell key={index} sx={{ color: 'white', fontWeight: 'bold', textAlign: 'center' }}>
                          {header}
                        </TableCell>
                      ))}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {objNoteCash && objNoteCash.map((note, idx) => (
                    <TableRow key={idx}>
                      <TableCell align="center">{note.date}</TableCell>
                      <TableCell align="center">{note.nro}</TableCell>
                      <TableCell align="center">{note.fullName}</TableCell>
                      <TableCell align="center">
                        <Stack direction="row" alignItems="center" justifyContent="center" spacing={1}>
                          <Typography>{note.phone}</Typography>
                          <a
                            href={`https://wa.me/${note.code_phone + '' + note.phone}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              backgroundColor: "#25D366",
                              borderRadius: "50%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              width: "24px",
                              height: "24px",
                              textDecoration: "none",
                            }}
                          >
                            <WhatsAppIcon style={{ color: "white", fontSize: "18px" }} />
                          </a>
                        </Stack>
                      </TableCell>
                      <TableCell align="center">{convertPrice((note.type == 0 ? '-' : '') + note.total, null, true)}</TableCell>

                    </TableRow>
                  ))}
                </TableBody>

                <TableFooter>
                  <TableRow sx={{ backgroundColor: 'var(--theme-company)' }}>
                    <TableCell colSpan={3} align="center" sx={{ color: 'white', fontWeight: 'bold' }}>
                      Total
                    </TableCell>
                    <TableCell align="center" sx={{ color: 'white', fontWeight: 'bold' }} />
                    <TableCell align="center" sx={{ color: 'white', fontWeight: 'bold' }}>
                      {convertPrice(totalGeneral)}
                    </TableCell>

                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          </div>
        ) : (
          <TablesMobile filteredData={(objNoteCash ?? []).map(obj => ({
            img: obj?.img_product,
            title: obj?.fullName,
            texto: convertPrice(obj?.total),
            other: obj?.date,
            fullPhone: obj?.code_phone + obj?.phone,
          }))} profile={false} whatsapp={true} mode="reportes" facturado={null} returnTotal={returnTotal} />
        )
      }
    </div>
  )
}
